//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { newNotification } from "@utdanningsdirektoratet/notifications";
import { hide, show } from "@utdanningsdirektoratet/progress";
import * as SlowAction from "@utdanningsdirektoratet/slowaction";
import { getAntiForgeryTokenInfo } from "./logic/initialState";
import {
  getValidationMessage,
  getValidationTitle,
  isProblemDetails,
  isValidationProblemDetailsObject,
} from "./utils/validationUtils";
export class ApiBase {
  protected transformOptions = (options: RequestInit): Promise<RequestInit> => {
    // Hack to prevent show from throwing an error about chaging state in an unmounted component on first render
    setTimeout(show, 0);
    if (options.method === "GET" || options.method === "HEAD") {
      return Promise.resolve(options);
    }
    const tokenInfo = getAntiForgeryTokenInfo();
    // eslint-disable-next-line no-param-reassign
    options.headers = {
      ...options.headers,
      [tokenInfo.tokenHeaderName!]: tokenInfo.requestToken,
    } as HeadersInit;
    return Promise.resolve(options);
  };

  protected transformResult = async <T>(
    _url: string,
    response: Response,
    onComplete: (response: Response) => Promise<T>,
  ): Promise<T> => {
    setTimeout(hide, 0);
    SlowAction.hide();
    if (!response.ok) {
      const contentType =
        response.headers.get("Content-Type")?.toLowerCase() ?? "text/plain";
      const isJson = contentType.indexOf("json") >= 0;
      if (isJson) {
        const error = await response.clone().json();
        if (isValidationProblemDetailsObject(error)) {
          newNotification(
            "error",
            getValidationTitle(error),
            getValidationMessage(error),
          );
          throw new Error(getValidationMessage(error));
        } else if (isProblemDetails(error)) {
          newNotification(
            "error",
            error.title ?? "En feil har oppstått",
            error.detail ?? undefined,
          );
          throw new Error(error.title ?? "En feil har oppstått");
        } else {
          newNotification("error", error.message);
          throw new Error(error.message);
        }
      }
    }

    return onComplete(response);
  };
}

export interface IFylkeClient {

    getFylker(): Promise<FylkeViewModel[]>;
}

export class FylkeClient extends ApiBase implements IFylkeClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getFylker(signal?: AbortSignal): Promise<FylkeViewModel[]> {
        let url_ = this.baseUrl + "/api/client/fylke";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFylker(_response));
        });
    }

    protected processGetFylker(response: Response): Promise<FylkeViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FylkeViewModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FylkeViewModel[]>(null as any);
    }
}

export interface IHoeringClient {

    get(hoeringId: number, forhandsVisningsKode: string | null | undefined, innsendingsKode: string | null | undefined): Promise<HøringViewModel>;

    submitUttalelse(hoeringId: number, innsendingsKode: string | null | undefined, eksternId: string | null, høringUttalelseSubmitModelV2: HøringUttalelseSubmitModelV2): Promise<SubmitViewModel>;

    lagreManuellRegistrering(hoeringId: number | undefined, eksternId: string, manuellRegistreringsKode: string, høringUttalelseSubmitModelV2: HøringUttalelseSubmitModelV2): Promise<string>;

    setIngenMerknader(eksternId: string, manuellRegistreringsKode: string, ingenMerknader: boolean): Promise<FileResponse>;

    autoSave(hoeringId: number, eksternId: string | null, model: HøringUttalelseSubmitModelV2): Promise<AutoSaveViewModel>;

    lagreUtkast(eksternId: string, innsendingsKode: string | null | undefined, innsenderEpost: string): Promise<UtkastViewModel>;

    delUtkast(innsendingsKode: string | null | undefined, eksternId: string | null, model: DelUtkastViewModel): Promise<UtkastViewModel>;

    lastOppSporsmaalUttalelseVedlegg(files: FileParameter[] | null | undefined, sporsmalId: number | undefined, eksternId: string | undefined): Promise<LastOppSporsmaalUttalelseVedleggViewModel>;

    slettSporsmaalUttalelseVedlegg(eksternId: string): Promise<SlettSporsmaalUttalelseVedleggViewModel>;

    endreEpost(eksternId: string, innsenderEpost: string | undefined, innsendingsKode: string | null | undefined): Promise<FileResponse>;
}

export class HoeringClient extends ApiBase implements IHoeringClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(hoeringId: number, forhandsVisningsKode: string | null | undefined, innsendingsKode: string | null | undefined, signal?: AbortSignal): Promise<HøringViewModel> {
        let url_ = this.baseUrl + "/api/client/hoering/get/{hoeringId}?";
        if (hoeringId === undefined || hoeringId === null)
            throw new Error("The parameter 'hoeringId' must be defined.");
        url_ = url_.replace("{hoeringId}", encodeURIComponent("" + hoeringId));
        if (forhandsVisningsKode !== undefined && forhandsVisningsKode !== null)
            url_ += "forhandsVisningsKode=" + encodeURIComponent("" + forhandsVisningsKode) + "&";
        if (innsendingsKode !== undefined && innsendingsKode !== null)
            url_ += "innsendingsKode=" + encodeURIComponent("" + innsendingsKode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<HøringViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HøringViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HøringViewModel>(null as any);
    }

    submitUttalelse(hoeringId: number, innsendingsKode: string | null | undefined, eksternId: string | null, høringUttalelseSubmitModelV2: HøringUttalelseSubmitModelV2, signal?: AbortSignal): Promise<SubmitViewModel> {
        let url_ = this.baseUrl + "/api/client/hoering/{hoeringId}/{eksternId}?";
        if (hoeringId === undefined || hoeringId === null)
            throw new Error("The parameter 'hoeringId' must be defined.");
        url_ = url_.replace("{hoeringId}", encodeURIComponent("" + hoeringId));
        if (eksternId === undefined || eksternId === null)
            throw new Error("The parameter 'eksternId' must be defined.");
        url_ = url_.replace("{eksternId}", encodeURIComponent("" + eksternId));
        if (innsendingsKode !== undefined && innsendingsKode !== null)
            url_ += "innsendingsKode=" + encodeURIComponent("" + innsendingsKode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(høringUttalelseSubmitModelV2);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubmitUttalelse(_response));
        });
    }

    protected processSubmitUttalelse(response: Response): Promise<SubmitViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubmitViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmitViewModel>(null as any);
    }

    lagreManuellRegistrering(hoeringId: number | undefined, eksternId: string, manuellRegistreringsKode: string, høringUttalelseSubmitModelV2: HøringUttalelseSubmitModelV2, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/client/hoering/ManuellRegistrering/{eksternId}/{manuellRegistreringsKode}?";
        if (eksternId === undefined || eksternId === null)
            throw new Error("The parameter 'eksternId' must be defined.");
        url_ = url_.replace("{eksternId}", encodeURIComponent("" + eksternId));
        if (manuellRegistreringsKode === undefined || manuellRegistreringsKode === null)
            throw new Error("The parameter 'manuellRegistreringsKode' must be defined.");
        url_ = url_.replace("{manuellRegistreringsKode}", encodeURIComponent("" + manuellRegistreringsKode));
        if (hoeringId === null)
            throw new Error("The parameter 'hoeringId' cannot be null.");
        else if (hoeringId !== undefined)
            url_ += "hoeringId=" + encodeURIComponent("" + hoeringId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(høringUttalelseSubmitModelV2);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLagreManuellRegistrering(_response));
        });
    }

    protected processLagreManuellRegistrering(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    setIngenMerknader(eksternId: string, manuellRegistreringsKode: string, ingenMerknader: boolean, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/client/hoering/SetIngenMerknader/{eksternId}/{manuellRegistreringsKode}";
        if (eksternId === undefined || eksternId === null)
            throw new Error("The parameter 'eksternId' must be defined.");
        url_ = url_.replace("{eksternId}", encodeURIComponent("" + eksternId));
        if (manuellRegistreringsKode === undefined || manuellRegistreringsKode === null)
            throw new Error("The parameter 'manuellRegistreringsKode' must be defined.");
        url_ = url_.replace("{manuellRegistreringsKode}", encodeURIComponent("" + manuellRegistreringsKode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ingenMerknader);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetIngenMerknader(_response));
        });
    }

    protected processSetIngenMerknader(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    autoSave(hoeringId: number, eksternId: string | null, model: HøringUttalelseSubmitModelV2, signal?: AbortSignal): Promise<AutoSaveViewModel> {
        let url_ = this.baseUrl + "/api/client/hoering/AutoSave/{hoeringId}/{eksternId}";
        if (hoeringId === undefined || hoeringId === null)
            throw new Error("The parameter 'hoeringId' must be defined.");
        url_ = url_.replace("{hoeringId}", encodeURIComponent("" + hoeringId));
        if (eksternId === undefined || eksternId === null)
            throw new Error("The parameter 'eksternId' must be defined.");
        url_ = url_.replace("{eksternId}", encodeURIComponent("" + eksternId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAutoSave(_response));
        });
    }

    protected processAutoSave(response: Response): Promise<AutoSaveViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutoSaveViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutoSaveViewModel>(null as any);
    }

    lagreUtkast(eksternId: string, innsendingsKode: string | null | undefined, innsenderEpost: string, signal?: AbortSignal): Promise<UtkastViewModel> {
        let url_ = this.baseUrl + "/api/client/hoering/LagreUtkast/{eksternId}?";
        if (eksternId === undefined || eksternId === null)
            throw new Error("The parameter 'eksternId' must be defined.");
        url_ = url_.replace("{eksternId}", encodeURIComponent("" + eksternId));
        if (innsendingsKode !== undefined && innsendingsKode !== null)
            url_ += "innsendingsKode=" + encodeURIComponent("" + innsendingsKode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(innsenderEpost);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLagreUtkast(_response));
        });
    }

    protected processLagreUtkast(response: Response): Promise<UtkastViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UtkastViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UtkastViewModel>(null as any);
    }

    delUtkast(innsendingsKode: string | null | undefined, eksternId: string | null, model: DelUtkastViewModel, signal?: AbortSignal): Promise<UtkastViewModel> {
        let url_ = this.baseUrl + "/api/client/hoering/DelUtkast/{eksternId}?";
        if (eksternId === undefined || eksternId === null)
            throw new Error("The parameter 'eksternId' must be defined.");
        url_ = url_.replace("{eksternId}", encodeURIComponent("" + eksternId));
        if (innsendingsKode !== undefined && innsendingsKode !== null)
            url_ += "innsendingsKode=" + encodeURIComponent("" + innsendingsKode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelUtkast(_response));
        });
    }

    protected processDelUtkast(response: Response): Promise<UtkastViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UtkastViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UtkastViewModel>(null as any);
    }

    lastOppSporsmaalUttalelseVedlegg(files: FileParameter[] | null | undefined, sporsmalId: number | undefined, eksternId: string | undefined, signal?: AbortSignal): Promise<LastOppSporsmaalUttalelseVedleggViewModel> {
        let url_ = this.baseUrl + "/api/client/hoering/LastOppSporsmaalUttalelseVedlegg";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (sporsmalId === null || sporsmalId === undefined)
            throw new Error("The parameter 'sporsmalId' cannot be null.");
        else
            content_.append("SporsmalId", sporsmalId.toString());
        if (eksternId === null || eksternId === undefined)
            throw new Error("The parameter 'eksternId' cannot be null.");
        else
            content_.append("EksternId", eksternId.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLastOppSporsmaalUttalelseVedlegg(_response));
        });
    }

    protected processLastOppSporsmaalUttalelseVedlegg(response: Response): Promise<LastOppSporsmaalUttalelseVedleggViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LastOppSporsmaalUttalelseVedleggViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LastOppSporsmaalUttalelseVedleggViewModel>(null as any);
    }

    slettSporsmaalUttalelseVedlegg(eksternId: string, signal?: AbortSignal): Promise<SlettSporsmaalUttalelseVedleggViewModel> {
        let url_ = this.baseUrl + "/api/client/hoering/SlettSporsmaalUttalelseVedlegg/{eksternId}";
        if (eksternId === undefined || eksternId === null)
            throw new Error("The parameter 'eksternId' must be defined.");
        url_ = url_.replace("{eksternId}", encodeURIComponent("" + eksternId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSlettSporsmaalUttalelseVedlegg(_response));
        });
    }

    protected processSlettSporsmaalUttalelseVedlegg(response: Response): Promise<SlettSporsmaalUttalelseVedleggViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SlettSporsmaalUttalelseVedleggViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SlettSporsmaalUttalelseVedleggViewModel>(null as any);
    }

    endreEpost(eksternId: string, innsenderEpost: string | undefined, innsendingsKode: string | null | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/client/hoering/EndreEpost/{eksternId}?";
        if (eksternId === undefined || eksternId === null)
            throw new Error("The parameter 'eksternId' must be defined.");
        url_ = url_.replace("{eksternId}", encodeURIComponent("" + eksternId));
        if (innsenderEpost === null)
            throw new Error("The parameter 'innsenderEpost' cannot be null.");
        else if (innsenderEpost !== undefined)
            url_ += "innsenderEpost=" + encodeURIComponent("" + innsenderEpost) + "&";
        if (innsendingsKode !== undefined && innsendingsKode !== null)
            url_ += "innsendingsKode=" + encodeURIComponent("" + innsendingsKode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEndreEpost(_response));
        });
    }

    protected processEndreEpost(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IInitialViewModel {

    index(): Promise<V2ViewModel>;
}

export class InitialViewModel extends ApiBase implements IInitialViewModel {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    index(signal?: AbortSignal): Promise<V2ViewModel> {
        let url_ = this.baseUrl + "/api/client/init";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIndex(_response));
        });
    }

    protected processIndex(response: Response): Promise<V2ViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as V2ViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<V2ViewModel>(null as any);
    }
}

export interface IUttalelseClient {

    getUttalelse(hoeringId: number, eksternId: string, leseTilgangsKode: boolean | undefined, forhandsVisningsKode: string | null | undefined): Promise<UttalelseViewModel>;
}

export class UttalelseClient extends ApiBase implements IUttalelseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getUttalelse(hoeringId: number, eksternId: string, leseTilgangsKode: boolean | undefined, forhandsVisningsKode: string | null | undefined, signal?: AbortSignal): Promise<UttalelseViewModel> {
        let url_ = this.baseUrl + "/api/client/uttalelse/get/{hoeringId}/{eksternId}?";
        if (hoeringId === undefined || hoeringId === null)
            throw new Error("The parameter 'hoeringId' must be defined.");
        url_ = url_.replace("{hoeringId}", encodeURIComponent("" + hoeringId));
        if (eksternId === undefined || eksternId === null)
            throw new Error("The parameter 'eksternId' must be defined.");
        url_ = url_.replace("{eksternId}", encodeURIComponent("" + eksternId));
        if (leseTilgangsKode === null)
            throw new Error("The parameter 'leseTilgangsKode' cannot be null.");
        else if (leseTilgangsKode !== undefined)
            url_ += "leseTilgangsKode=" + encodeURIComponent("" + leseTilgangsKode) + "&";
        if (forhandsVisningsKode !== undefined && forhandsVisningsKode !== null)
            url_ += "forhandsVisningsKode=" + encodeURIComponent("" + forhandsVisningsKode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUttalelse(_response));
        });
    }

    protected processGetUttalelse(response: Response): Promise<UttalelseViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UttalelseViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UttalelseViewModel>(null as any);
    }
}

export interface IVersionClient {

    getVersion(): Promise<string>;
}

export class VersionClient extends ApiBase implements IVersionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getVersion(signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/client/version/get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetVersion(_response));
        });
    }

    protected processGetVersion(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface FylkeViewModel {
    navn: string;
    fylkesNr: string;
    kommuner: KommuneViewModel[];
    aktiv: boolean;
}

export interface KommuneViewModel {
    navn: string;
    orgNr: string;
    kommuneNr: string;
    aktiv: boolean;
}

export interface HøringViewModel {
    lukketInnsending: boolean;
    "målgrupper": MalgruppeViewModel[];
    "forhåndsvisnings": boolean;
    mode: string;
    notater: HøringsNotatViewModel[];
    vedlegg: VedleggViewModel[];
    publiseringsStatus: PubliseringsStatus;
    "målforms": Målforms;
    kanHaIngenMerknader: boolean;
    isExpired: boolean;
    isClosedOrExpired: boolean;
    isLukketForUttalelser: boolean;
    skjult: boolean;
    publisert?: Date | null;
    frist?: Date | null;
    tittel: MålformString;
    id: number;
}

export interface MalgruppeViewModel {
    tittel: string;
    id: number;
    "rekkefølge": number;
    sektor: Sektor;
    erAktiv: boolean;
    innsenderRepresentererObligatoriskhet: Obligatoriskhet;
    innsenderStillingObligatoriskhet: Obligatoriskhet;
    geografiObligatoriskhet: GeografiObligatoriskhet;
    "målgruppeUnderTyper": MalgruppeUnderTypeViewModel[];
    kanHaFlereUndertyper: boolean;
    undertypeErObligatorisk: boolean;
    innsenderRepresentererEtikett?: string | null;
    bekreftRepresentasjon: boolean;
    autoPubliser: boolean;
    arkiverSomPerson: boolean;
    bekreftRepresentasjonFeilMelding: MålformString;
    bekreftRepresentasjonTekst: MålformString;
}

export enum Sektor {
    Offentlig = "Offentlig",
    Privat = "Privat",
    Enkeltperson = "Enkeltperson",
}

export enum Obligatoriskhet {
    Obligatorisk = "Obligatorisk",
    Valgfritt = "Valgfritt",
    IkkeEtterspør = "IkkeEtterspør",
}

export enum GeografiObligatoriskhet {
    IkkeEtterspør = "IkkeEtterspør",
    FylkeObligatorisk = "FylkeObligatorisk",
    FylkeOgKommuneObligatorisk = "FylkeOgKommuneObligatorisk",
}

export interface MalgruppeUnderTypeViewModel {
    tittel: string;
    id: number;
    erAktiv: boolean;
    "rekkefølge": number;
}

export interface MålformString {
    nb?: string | null;
    nn?: string | null;
}

export interface HøringsNotatViewModel {
    seksjoner: SeksjonViewModel[];
    signaturSeksjon?: SignaturSeksjonViewModel | null;
    vedlegg: VedleggViewModel[];
    fotnoter?: Fotnote[] | null;
    saksBehandlereTekst?: string | null;
    kanHaGenerellKommentar: boolean;
    kanHaGenerellHoldning: boolean;
    arkivDisplayNummer?: string | null;
    menyTittel: MålformString;
    visInnholdsfortegnelse: boolean;
    skjulNummerering: boolean;
    tittel: MålformString;
    "rekkefølge": number;
    id: number;
}

export interface SeksjonViewModel {
    nummerering: string;
    "spørsmål": SpørsmålViewModel[];
    tittel: MålformString;
    "rekkefølge": number;
    "nivå": number;
    "brødTekst": MålformString;
    kanHaMarkering: boolean;
    id: number;
}

export interface SpørsmålViewModel {
    jaNei: SvarMulighetViewModel;
    enigUenig: SvarMulighetViewModel;
    positivNegativ: SvarMulighetViewModel;
    svarAlternativer: EttFlereValgMulighetViewModel;
    heltall: SvarMulighetViewModel;
    kortTekst: KortSvarMulighetViewModel;
    kommentar: KommentarSvarMulighetViewModel;
    vedlegg: SvarMulighetViewModel;
    dato: SvarMulighetViewModel;
    fylkeKommune: FylkeKommuneSvarMulighetViewModel;
    tittel: MålformString;
    "rekkefølge": number;
    "brødTekst": MålformString;
    id: number;
}

export interface SvarMulighetViewModel {
    canHave: boolean;
    isObligatorisk: boolean;
}

export interface EttFlereValgMulighetViewModel extends SvarMulighetViewModel {
    flereValg: boolean;
    svarAlternativ: SvarAlternativViewModel[];
}

export function isEttFlereValgMulighetViewModel(object: any): object is EttFlereValgMulighetViewModel {
    return object && object[''] === 'EttFlereValgMulighetViewModel';
}

export interface SvarAlternativViewModel {
    id: number;
    "rekkefølge": number;
    erEgendefinert: boolean;
    tittel: MålformString;
}

export interface KortSvarMulighetViewModel extends SvarMulighetViewModel {
    type: KortSvarTypes;
}

export function isKortSvarMulighetViewModel(object: any): object is KortSvarMulighetViewModel {
    return object && object[''] === 'KortSvarMulighetViewModel';
}

export enum KortSvarTypes {
    Tekst = "Tekst",
    Epost = "Epost",
    Orgnr = "Orgnr",
    Kontonr = "Kontonr",
}

export interface KommentarSvarMulighetViewModel extends SvarMulighetViewModel {
    obligatoriskKommentarEnigUenig?: string[] | null;
    obligatoriskKommentarJaNei?: string[] | null;
    obligatoriskKommentarPositivNegativ?: string[] | null;
    maxAntallTegn?: number | null;
}

export function isKommentarSvarMulighetViewModel(object: any): object is KommentarSvarMulighetViewModel {
    return object && object[''] === 'KommentarSvarMulighetViewModel';
}

export interface FylkeKommuneSvarMulighetViewModel extends SvarMulighetViewModel {
    type?: FylkeKommuneTypes | null;
    flereFylker?: boolean | null;
    flereKommuner?: boolean | null;
}

export function isFylkeKommuneSvarMulighetViewModel(object: any): object is FylkeKommuneSvarMulighetViewModel {
    return object && object[''] === 'FylkeKommuneSvarMulighetViewModel';
}

export enum FylkeKommuneTypes {
    FylkeKommune = "FylkeKommune",
    Fylke = "Fylke",
    Kommune = "Kommune",
}

export interface SignaturSeksjonViewModel {
    hilsen: MålformString;
    footer: MålformString;
    signaturNavn1?: string | null;
    signaturStilling1: MålformString;
    signaturNavn2?: string | null;
    signaturStilling2: MålformString;
}

export interface VedleggViewModel {
    filNavn: string;
    id: number;
}

export interface Fotnote {
    id: number;
    wordId: string;
    text: string;
}

export enum PubliseringsStatus {
    IkkePublisert = "IkkePublisert",
    PublisertÅpen = "PublisertÅpen",
    PublisertLukket = "PublisertLukket",
}

export enum Målforms {
    Bokmål = "Bokmål",
    Nynorsk = "Nynorsk",
}

export interface SubmitViewModel {
    eksternId: string;
    hoeringId: number;
    bekreftetStatus: BekreftetStatus;
}

export enum BekreftetStatus {
    IkkeBekreftet = "IkkeBekreftet",
    AvInnsender = "AvInnsender",
    AvSaksBehandler = "AvSaksBehandler",
    LukketInnsending = "LukketInnsending",
    ManueltRegistrert = "ManueltRegistrert",
    TrengerIkkeBekreftes = "TrengerIkkeBekreftes",
}

export interface HøringUttalelseSubmitModelV2 {
    eksternId: string;
    sporsmalUttalelser?: SpørsmålUttalelseSubmitModel[] | null;
    seksjonUttalelser?: SeksjonUttalelseSubmitModel[] | null;
    notatUttalelser?: HøringsNotatUttalelseSubmitModel[] | null;
    innsender?: InnsenderViewModel | null;
    ingenMerknader: boolean;
    "userMålform": Målform;
}

export interface SpørsmålUttalelseSubmitModel {
    id: number;
    positivNegativHoldning?: PositivNegativHoldning | null;
    jaNei?: JaNei | null;
    enigUenig?: EnigUenig | null;
    kommentar?: string | null;
    kortTekst?: string | null;
    heltall?: number | null;
    dato?: Date | null;
    fylkeKommune?: string[] | null;
    "svarPåSvarAlternativer"?: number[] | null;
    egendefinertSvar?: EgendefinertSvarModel[] | null;
}

export enum PositivNegativHoldning {
    IkkeAngitt = "IkkeAngitt",
    Positiv = "Positiv",
    Negativ = "Negativ",
    HverkenEller = "HverkenEller",
}

export enum JaNei {
    IkkeAngitt = "IkkeAngitt",
    Ja = "Ja",
    Nei = "Nei",
    VetIkke = "VetIkke",
}

export enum EnigUenig {
    IkkeAngitt = "IkkeAngitt",
    HeltUenig = "HeltUenig",
    DelvisUenig = "DelvisUenig",
    HverkenEller = "HverkenEller",
    DelvisEnig = "DelvisEnig",
    HeltEnig = "HeltEnig",
}

export interface EgendefinertSvarModel {
    svarAlternativId: number;
    egendefinertSvar: string;
}

export interface SeksjonUttalelseSubmitModel {
    id: number;
}

export interface HøringsNotatUttalelseSubmitModel {
    id: number;
    generellKommentar?: string | null;
    generellHoldning?: PositivNegativHoldning | null;
}

export interface InnsenderViewModel {
    navn: string;
    epost: string;
    malgruppe: number;
    representerer?: string | null;
    stilling?: string | null;
    fylke?: string | null;
    kommune?: string | null;
    undertype: number[];
}

export enum Målform {
    Bokmål = "Bokmål",
    Nynorsk = "Nynorsk",
}

export interface AutoSaveViewModel {
    endret?: Date | null;
    hoeringId: number;
    eksternId: string;
}

export interface UtkastViewModel {
    title?: string | null;
    message?: string | null;
}

export interface DelUtkastViewModel {
    eksternId: string;
    "userMålform": Målform;
    innsenderEpost: string;
    mottakerEpost?: string[] | null;
    kommentar: string;
    skrivetilgang: boolean;
}

export interface LastOppSporsmaalUttalelseVedleggViewModel {
    files: SpørsmålUttalelseVedleggViewModel[];
    errors: string;
}

export interface SpørsmålUttalelseVedleggViewModel {
    filNavn: string;
    eksternId: string;
    lastetOpp?: string | null;
}

export interface SlettSporsmaalUttalelseVedleggViewModel {
    eksternId?: string | null;
}

export interface ProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;
}

export interface HttpValidationProblemDetails extends ProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export function isHttpValidationProblemDetails(object: any): object is HttpValidationProblemDetails {
    return object && object[''] === 'HttpValidationProblemDetails';
}

/** A ProblemDetails for validation errors. */
export interface ValidationProblemDetails extends HttpValidationProblemDetails {
    /** Gets or sets the validation errors associated with this instance of ValidationProblemDetails. */
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export function isValidationProblemDetails(object: any): object is ValidationProblemDetails {
    return object && object[''] === 'ValidationProblemDetails';
}

export interface V2ViewModel {
    tittel: string;
    beskrivelse: string;
    cssUrl?: string | null;
    faviconUrl: string;
    logoUrl: string;
    opengraphUrl: string;
    froalaLicense?: string | null;
    sentryId?: string | null;
    matomoTagManager?: string | null;
    institusjonNavnLang: string;
    hoeringUrls: HoeringUrls;
    antiForgeryTokenInfo: AntiForgeryTokenInfo;
    texts: InitialStateTekst;
    footer?: UrlItem[] | null;
    personvernerklaering?: any | null;
    features: { [key: string]: FeatureListViewModel; };
    version: string;
    consoleLogTriggerMessage: string;
}

export interface HoeringUrls {
    lastNedVedlegg?: string | null;
    lastNedUtkastUrl?: string | null;
    lastNedUttalelseUrl?: string | null;
    "lastNedSpørsmålUttalelseVedlegg"?: string | null;
}

export interface AntiForgeryTokenInfo {
    tokenHeaderName: string;
    requestToken: string;
}

export interface InitialStateTekst {
    nb: any;
    nn: any;
}

export interface UrlItem {
    tekst: string;
    url: string;
    blank: boolean;
}

export interface FeatureListViewModel {
    kommentarMaxAntallTegn: boolean;
    svarIngenMerknader: boolean;
    enSakPerSvarInnstilling: boolean;
    sendInnKunSisteNotat: boolean;
    lenkeTilPersonvernerklaering: boolean;
    bekrefteSvar: boolean;
}

export interface UttalelseViewModel {
    endret?: Date | null;
    malgruppeId?: number | null;
    "høringId": number;
    hasFeedback: boolean;
    status?: string | null;
    bekreftelsesUri?: string | null;
    "spørsmål": SpørsmålUttalelseViewModel[];
    seksjoner: SeksjonUttalelseViewModel[];
    innsenderRepresentererEtikett?: string | null;
    malgruppe?: string | null;
    sektor?: Sektor | null;
    innsenderNavn?: string | null;
    innsenderEpost?: string | null;
    innsenderStilling?: string | null;
    "påVegneAv"?: string | null;
    notater: HøringsNotatUttalelseViewModel[];
    "userMålform": Målform;
    id: number;
    navnSkjult: boolean;
    ingenMerknader: boolean;
    innsendt: boolean;
    manueltRegistrert: boolean;
    mottatt?: Date | null;
    bekreftetStatus: BekreftetStatus;
    arkivnummer?: string | null;
    eksternId: string;
}

export interface SpørsmålUttalelseViewModel {
    "svarPåSvarAlternativer": SvarPåAlternativViewModel[];
    id: number;
    "spørsmålId": number;
    jaNei: JaNei;
    enigUenig: EnigUenig;
    positivNegativHoldning: PositivNegativHoldning;
    heltall?: number | null;
    kortTekst?: string | null;
    kommentar?: string | null;
    vedlegg: SpørsmålUttalelseVedleggViewModel[];
    dato?: Date | null;
    fylkeKommune?: string[] | null;
}

export interface SvarPåAlternativViewModel {
    flereValg: boolean;
    egendefinertSvar?: string | null;
    svarAlternativId: number;
    id?: number | null;
}

export interface SeksjonUttalelseViewModel {
    seksjonId: number;
    id: number;
}

export interface HøringsNotatUttalelseViewModel {
    notatId: number;
    id: number;
    hasFeedback: boolean;
    generellHoldning: PositivNegativHoldning;
    generellKommentar?: string | null;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

/* eslint-disable class-methods-use-this */